import React from 'react';
import { Outlet } from 'react-router-dom';

const MainInvoice = () => {
    return (
        <div>
            <Outlet></Outlet>
        </div>
    );
};

export default MainInvoice;